// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"c3a9d2cf","tabContainer":"a4f48002","tab":"a1787d99","active":"adaa1aae"};